import {
  SET_GLOBAL_REPAIR_SERVICES,
  CLEAR_GLOBAL_REPAIR_SERVICES
} from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.globalRepair, { type, payload }) {
  switch (type) {
    case SET_GLOBAL_REPAIR_SERVICES:
      return [...payload];
    case CLEAR_GLOBAL_REPAIR_SERVICES:
    case RESET_APP_STATE:
      return initialState.globalRepair;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/globalRepair/reducer.js